<div class="message-container scu-typography" [ngClass]="alertMessage.type">
  <div class="message">
    <div class="message-content">
      <div class="message-icon">
        <app-icon [size]="24" [name]="alertMessage.icon" class="scu-semi-bold"></app-icon>
      </div>
      <div class="message-meta-data scu-body-1 scu-semi-bold">
        @if (alertMessage.code) {
          <span class="message-code">{{ alertMessage.code }} : </span>
        }
        @if (alertMessage.title) {
          <span class="message-title">{{ alertMessage.title }}</span>
        }
      </div>
      @if (alertMessage.message) {
        <div class="message-text scu-body-2">
          {{ alertMessage.message }}
        </div>
      }
    </div>
  </div>
  <app-icon name="xmark" class="close-icon" (click)="closeMessage()"></app-icon>
</div>
